module.exports = __webpack_public_path__ + "assets/img/trust_7.e4b65616.png";